import { Controller } from "@hotwired/stimulus"
import { create } from "@github/webauthn-json"

export default class extends Controller {
  static targets = ["button", "status"]
  static values  = { optionsUrl: String, registerUrl: String }

  async register() {
    this.buttonTarget.disabled = true
    this.show("Setting up passkey…")

    try {
      const options    = await this.fetchJson(this.optionsUrlValue, "POST")
      const credential = await create({ publicKey: options })
      const result     = await this.fetchJson(this.registerUrlValue, "POST", { credential })

      if (result.redirect_url) {
        window.location.href = result.redirect_url
      } else {
        this.show(result.error || "Registration failed. Please try again.")
        this.buttonTarget.disabled = false
      }
    } catch (error) {
      this.show(error.message || "Something went wrong. Please try again.")
      this.buttonTarget.disabled = false
    }
  }

  show(message) {
    this.statusTarget.textContent = message
    this.statusTarget.classList.remove("hidden")
  }

  async fetchJson(url, method, body = null) {
    const headers = {
      "Accept": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
    }
    if (body) headers["Content-Type"] = "application/json"

    const response = await fetch(url, {
      method,
      headers,
      body: body ? JSON.stringify(body) : null
    })
    return response.json()
  }
}
